var $069eb2e0b73d269e$exports = {};
$069eb2e0b73d269e$exports = {
    "colorSwatchPicker": `\u{8272}\u{7968}`,
    "dropzoneLabel": `\u{653E}\u{7F6E}\u{5340}`,
    "selectPlaceholder": `\u{9078}\u{53D6}\u{9805}\u{76EE}`,
    "tableResizer": `\u{5927}\u{5C0F}\u{8ABF}\u{6574}\u{5668}`
};


export {$069eb2e0b73d269e$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
